const einDashboard = {
  einDashboard: {
    installingSince: 'Enphase-Installationen seit',
    accountManager: 'Kundenbetreuer',
    installationShare: 'Anteil von Enphase Installationen',
    nps: 'Net Promoter Score (Kundenzufriedenheit)',
    viewDashboard: 'Dashboard anzeigen',
    quarterInfo: 'Stand: Q%{quarter},%{year} (Eigenheim)',
    npsTooltip: `Der Net Promoter Score ist ein Index zwischen -100 und 100, der die Bereitschaft der Kunden misst, Produkte oder Dienstleistungen eines Unternehmens anderen zu empfehlen. Diese Bewertung basiert auf den Bewertungen Ihrer Kunden in der Enlighten Mobile App für Ihre Dienste und ist nur für Sie und Enphase sichtbar. Der Standardzeitraum für die Daten beträgt die letzten 13 Monate.`,
    activity: 'Tätigkeit',
    sites: 'Anlagen',
    batteries: 'Batterien',
    acb: 'ACB',
    certifications: 'Zertifizierungen',
    community: 'Community',
    storage: 'Speicherstandorte',
    lastInstalledLabel: 'in den letzten 12 Monaten installiert',
    lastCommissionedLabel: 'in Betrieb genommen (in den letzten 12 Monaten)',
    viewDetails: 'Details anzeigen',
    seeReviews: 'Beurteilungen anzeigen',
    viewCommunity: 'Community anzeigen',
    certificateLabel: '%{count} von %{totalCount} Zertifizierungen abgeschlossen',
    networkLabel: {
      one: '%{count} Beitrag, letzter Beitrag: %{postDate}',
      other: '%{count} Beiträge, letzter Beitrag: %{postDate}'
    },
    requestProductAccess: 'Produktzugriff anfordern',
    inverter: 'IQ-8',
    ensemble: 'Ensemble 2.0',
    permit: 'Genehmigungsunterstützung',
    sgip: 'SGIP-Assistenz',
    learnMore: 'Mehr erfahren',
    aboutProduct: 'über das Produkt',
    betaReleaseDate: 'Datum der Beta-Ausgabe',
    requestEarlyAccess: 'Frühen Zugriff anfordern',
    viewAllProduct: 'Alle Produkte anzeigen',
    signUp: 'Ich möchte künftig über',
    betaReleaseLabel: 'alle Beta-Produktneuheiten informiert werden.',
    financing: 'Finanzierungsunterstützung',
    digitalPlatform: 'Digitale Plattform',
    lpp: 'LPP',
    requestedText: 'Anfrage für frühen Zugriff gesendet',
    grantedText: 'Beta-Zugriff gewährt',
    products: 'Produkte',
    ratingsReviews: 'Bewertungen und Beurteilungen',
    reviews: 'Beurteilungen',
    otherReviews: 'Sonstige Beurteilungen',
    updateDetails: 'Details aktualisieren',
    totalSavings: 'Gesamteinsparungen',
    inLastYear: 'In den letzten 12 Monaten',
    viewBreakdown: 'Aufschlüsselung anzeigen',
    leadsReceived: 'Leads erhalten',
    leadsClosure: 'Leads-Abschluss',
    leadsWon: 'Leads gewonnen',
    creditAvailable: 'Verfügbares Guthaben',
    buyMore: 'Mehr kaufen',
    messageFromCeo: 'Nachricht von unserem CEO',
    communityUpdates: 'Community Updates',
    makeAppointments: 'Termine vereinbaren',
    applicableText: 'Gilt nur für Platin-Mitglieder',
    view: 'Anzeigen',
    downloadAll: 'Alle herunterladen',
    promoteText: 'Werben Sie für Ihr Unternehmen mit Badges und Logos\u200b',
    asOfText: 'Stand: %{date}',
    yearTotal: 'Gesamt/Jahr',
    redeemed: 'Eingelöst',
    laborProtectionPlan: 'Arbeitsschutzprogramm',
    acmPromotion: 'ACM-Promotion',
    save: {
      lre_data: 'Einsparungen aus LPP',
      permit_data: 'Einsparungen aus Genehmigungen',
      financing_data: 'Einsparungen aus Finanzierung',
      sgip_data: 'Einsparungen aus SGIP',
      warrantyExtension: 'Einsparungen auf Garantieverlängerung'
    },
    platinumLogo: 'Platin-Logo',
    enphaseLogo: 'Enphase Logo',
    otherAssets: 'Sonstige Aktiva',
    ensembleCertificate: 'Ensemble 1.0 zertifiziert',
    salesCertificate: 'Sales 1.0 zertifiziert',
    marketingCertificate: 'Marketing 1.0 zertifiziert',
    solarInstallCertificate: 'Solar-zertifiziert',
    validTill: 'Gültig bis: %{date}',
    noDataAvailable: 'Keine Daten verfügbar',
    notAvailable: 'Nicht verfügbar',
    notApplicable: 'Nicht zutreffend',
    title: 'EIN Dashboard',
    infoNotAvailable: 'Informationen nicht verfügbar',
    congratulationSignUp:
      'Glückwunsch! Jetzt haben Sie frühzeitig Zugriff auf alle neuen Enphase-Produkte/-Dienstleistungen',
    benefits: 'Leistungen',
    installationShareTooltip: 'Diese Zahl gibt an, wie viel Prozent Ihrer Gesamtanlagen Enphase-Anlagen waren',
    dataFromThirdParty: '*Gemäß Daten von Drittanbietern',
    reviewsNotAvailable: 'Keine Bewertungen verfügbar',
    enphaseExecutive: 'Enphase-Exekutive',
    digitalAssets: 'Digitale Ressourcen',
    leads: 'Leads',
    tierSavings: 'Stufenersparnis',
    exclusiveUpdates: 'Exklusive Aktualisierungen',
    executiveSponsor: 'Exekutiver Sponsor',
    merchandise: 'Handelswaren',
    certifiedUsers: 'Zertifizierte Benutzer',
    noteAllowedOnce: 'Hinweis: Der obige Link kann nach der Erstellung nicht mehr bearbeitet werden',
    saveLink: `Link speichern`,
    confirm: `Bestätigen`,
    copyLink: 'Link kopieren',
    allowedCharactersError:
      'Es sind nur Buchstaben, Zahlen, Bindestriche und Unterstriche zulässig (maximal 500 Zeichen)',
    createSystemEstimatorLink: `Erstellen Sie Ihren personalisierten System Estimator-Link und teilen Sie ihn Ihren Kunden mit, um Hinweise von ihnen zu erhalten. Alle über diesen Link generierten Hinweise werden nur in Ihrem Enlighten-Manager an Sie weitergegeben.`,
    shareSystemEstimatorLink: `Teilen Sie Ihren Kunden Ihren personalisierten System Estimator-Link mit, um Hinweise von ihnen zu erhalten. Alle über diesen Link generierten Hinweise werden nur in Ihrem Enlighten-Manager an Sie weitergegeben.`,
    systemEstimatorLink: 'Estimator Link des Systems ',
    confirmChanges: 'Änderungen bestätigen',
    confirmSELink:
      'Bitte bestätigen Sie den Estimator Link Ihres Systems.  Dieser Link kann nach dem Speichern nicht mehr bearbeitet werden.',
    copied: `Kopiert`,
    mySELink: 'Mein Estimator-Link des Systems',
    sdtUrlExistsError: 'This link is already in use by another installer. Please choose a different link',
    all: 'Alle',
    filterText: 'Filter',
    noProductAvailable: 'Kein Produkt verfügbar'
  }
};

export default einDashboard;
